import {
    GET_DASHBOARD_FILTERS_CACHE_KEY,
    getForceDefaultFilters,
} from 'components/QueryPerimeter/hooks/useGetDashboardFilters';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { DashboardT } from 'business/definitions';
import { GET_DEFAULT_DASHBOARD_FILTERS_QUERY_KEY } from './useGetDefaultDashboardFilters';

export const updateDashboardDefaultFilter = async (
    updatedFilterProps: Pick<
        DashboardFilterT,
        'value' | 'valueScale' | 'operation'
    >,
    dashboardKey: number,
    filterKey: number,
): Promise<DashboardFilterT> => {
    const response = await RQAPICallWithData<DashboardFilterT>({
        endpoint: `explore/dashboard/${dashboardKey}/filter/${filterKey}/value`,
        method: 'PUT',
        body: updatedFilterProps,
    });
    return response.content.data;
};

const useUpdateDashboardDefaultFilter = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({
            filterKey,
            updatedFilterProps,
            dashboard,
        }: {
            dashboard: DashboardT;
            filterKey: number;
            updatedFilterProps: Pick<
                DashboardFilterT,
                'value' | 'valueScale' | 'operation'
            >;
        }) =>
            updateDashboardDefaultFilter(
                updatedFilterProps,
                dashboard.key,
                filterKey,
            ),

        onSuccess: (_data: DashboardFilterT, { dashboard }) => {
            queryClient.invalidateQueries({
                queryKey: [
                    GET_DASHBOARD_FILTERS_CACHE_KEY,
                    dashboard.key,
                    getForceDefaultFilters(),
                ],
            });
            queryClient.invalidateQueries({
                queryKey: [
                    GET_DEFAULT_DASHBOARD_FILTERS_QUERY_KEY,
                    dashboard.slug,
                ],
            });
        },
        meta: { useGlobalOnError: true },
    });
};

export default useUpdateDashboardDefaultFilter;
